import React from "react";
import type { UserDto } from "client/api/UsersApi";
import { updateUser } from "client/api/UsersApi";
import { useEntity } from "components/EntityProvider/EntityProvider";
import type { UserFormInputs } from "components/users/UserForm";
import { UserForm } from "components/users/UserForm";

export function UserDetails() {
  const { entity: user, refresh: refreshUser } = useEntity<UserDto>();

  if (!user) {
    return <></>;
  }

  const saveUser = async (params: UserFormInputs) => {
    await updateUser(user.id, {
      firstName: params.firstName,
      lastName: params.lastName,
    });
    refreshUser && refreshUser();
  };
  return <UserForm header="Details" existingUser={user} onSubmit={saveUser} />;
}
